module.exports = __webpack_public_path__ + "static/img/szafa_9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_9.svg
// module id = Om38
// module chunks = 0